import type { TabCampaignListing } from './CampaignListingTab';

import { useCampaignFilterContext } from '../../contexts/CampaignFilterProvider';
import { Box, Icon, InlineStack, Text } from '@shopify/polaris';
import { G_BOX_CARD_DEFAULT_PROPS } from '~/presentation/ui';
import { useToggle } from '~/hooks/useToggle';
import { useMemo } from 'react';

interface CampaignListingTabItemProps {
  item: TabCampaignListing;
}

export const CampaignListingTabItem: React.FC<CampaignListingTabItemProps> = ({ item }) => {
  const { setFalse, setTrue, value: isHover } = useToggle(false);
  const { campaignType, handleCampaignTypeChange } = useCampaignFilterContext();

  const isActive = campaignType === item.key;
  const boxBackground = useMemo(() => {
    if (isActive) return G_BOX_CARD_DEFAULT_PROPS['background'];
    if (isHover) return 'bg';
    return 'bg-surface-secondary';
  }, [isHover, isActive]);

  return (
    <div
      onClick={() => handleCampaignTypeChange(item.key)}
      className="cursor-pointer"
      onMouseEnter={setTrue}
      onMouseLeave={setFalse}
    >
      <Box
        paddingInline={{ xs: '200', md: '400' }}
        paddingBlock="300"
        borderRadius={G_BOX_CARD_DEFAULT_PROPS['borderRadius']}
        borderColor="border-inverse-active"
        borderWidth={'025'}
        borderBlockEndWidth="0"
        borderEndEndRadius="0"
        borderEndStartRadius="0"
        outlineWidth="0"
        background={boxBackground}
      >
        <InlineStack gap="100" align="center" blockAlign="center">
          <Icon source={item.icon} tone="subdued" />
          <Text as="p" variant="bodySm" fontWeight="semibold" tone="subdued">
            {item.name}
          </Text>
        </InlineStack>
      </Box>
    </div>
  );
};
